import React from 'react';
import { View, Text } from 'react-native';
import { TextInput } from 'react-native-paper';
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import styles from './styles';

const ConfirmSearchUserSell = () => {
    return (
        <>
            <HeaderDefault title={<FormattedMessage id='confirmSearchUserSell.headerBuscar'/>} />

            <View style={styles.container}>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='confirmSearchUserSell.txtMoeda'/></Text>
                    <Text><FormattedMessage id='confirmSearchUserSell.txtGpxToken'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='confirmSearchUserSell.txtValorDoDia'/></Text>
                    <Text><FormattedMessage id='confirmSearchUserSell.txtValorDoDiaGpx'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='confirmSearchUserSell.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='confirmSearchUserSell.txtNome'/></Text>
                </View>

                <Text style={styles.descriptionInput}><FormattedMessage id='confirmSearchUserSell.txtDefineValorVenda'/></Text>

                <TextInput
                    left={<TextInput.Icon name="currency-brl" />}
                    style={{ backgroundColor: "#F2F2F2", marginTop: 20 }}
                    keyboardType="numeric"
                />
                <Text style={styles.price}><FormattedMessage id='confirmSearchUserSell.txtCotacaoGpx'/></Text>
            </View>

            <Button route={"ConfirmPassword"} text={<FormattedMessage id='confirmSearchUserSell.txtBtnConfirmar'/>} titlePage={<FormattedMessage id='confirmSearchUserSell.txtBtnConfirmaVenda'/>} />
        </>
    );
}

export default ConfirmSearchUserSell;